<template>
  <div class="demandServer">
    <el-tabs
      v-model="activeName"
      label="left"
      tab-position="left"
      type="card"
      @tab-click="handleClick"
    >
      <el-tab-pane label="需" name="first">
        <div class="box_tabs">
          <h2 class="box_tabs_title">我是需求方</h2>
          <p class="box_tabs_mesg">服务商资源浏览，需求信息发布</p>
          <div class="demand_mesg">
            <div
              class="demand_mesg_box"
              v-for="(item, index) in demandList"
              :key="index"
              @click="skipFeaturePage(item)"
            >
              <div style="text-align: right">
                <img class="imgs" :src="item.imgs" />
              </div>
              <h2 class="demand_mesg_nums">{{ item.nums }}</h2>
              <p class="demand_mesg_name">{{ item.name }}</p>
              <p class="demand_mesg_p">{{ item.mesg }}</p>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="供" name="fourth">
        <div class="box_tabs box_tabs2">
          <h2 class="box_tabs_title">我是服务商</h2>
          <p class="box_tabs_mesg">需求信息浏览，服务资源发布</p>
          <div class="server_mesg">
            <div class="server_box">
              <div
                class="server_mesg_box"
                v-for="(item, index) in serverList"
                @click="skipFeaturePage(item)"
                :key="index"
              >
                <img class="imgs" :src="item.imgs" />
                <div class="server_mesg_numsBox">
                  <h2 class="server_mesg_nums">{{ item.nums }}</h2>
                  <div class="serverP">
                    <p class="server_mesg_name">{{ item.name }}</p>
                    <p class="server_mesg_p">{{ item.mesg }}</p>
                  </div>
                </div>
              </div>
            </div>
            <el-carousel height="282px" style="width: 669px">
              <el-carousel-item v-for="item in adList" :key="item">
                <img :src="item.value" class="server_mesg_img" @click="onLink(item.linkUrl)"/>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  findSellerSettledInfo,
  getBannerList,
  getNewcurrent,
} from "../../utils/interface";
export default {
  data() {
    return {
      activeName: "first",
      demandList: [
        {
          nums: "01",
          name: "寻找服务",
          mesg: "匹配您的需求",
          link: "/serviceList",
          imgs: require("../../assets/supplyHome/myserver1.png"),
        },
        {
          nums: "02",
          name: "发布需求",
          mesg: "让专业服务商来找您",
          link: "/publishDemand",
          type: "buyerWeb",
          imgs: require("../../assets/supplyHome/myserver2.png"),
        },
        {
          nums: "03",
          name: "联系服务商",
          mesg: "服务商资源直接对接",
          link: "/qualityServiceProviderList",
          imgs: require("../../assets/supplyHome/myserver3.png"),
        },
      ],
      serverList: [
        {
          nums: "01",
          name: "寻找需求",
          mesg: "浏览需求，寻找商机",
          link: "/demandList",
          imgs: require("../../assets/supplyHome/myserver1.png"),
        },
        {
          nums: "02",
          name: "发布服务",
          mesg: "资源互补，合作共赢",
          link: "/publishService",
          type: "sellerWeb",
          imgs: require("../../assets/supplyHome/myserver2.png"),
        },
        {
          nums: "03",
          name: "邀您入驻",
          mesg: "入驻平台，尊享全部服务!",
          link: "/enter",
          authentication: true,
          imgs: require("../../assets/supplyHome/myserver3.png"),
        },
      ],
      adList: []
    };
  },
  mounted() {
    this.loadAd();
  },
  methods: {
    onLink(linkUrl) {
      if (linkUrl) {
        window.open(linkUrl, "_blank");
      }
    },
    loadAd(){
      getBannerList({groupCode: 'RESOURCE_AD_IMG'}).then((res)=>{
        this.adList = res;
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    skipFeaturePage(item) {
      let routeData = "";
      if(item.authentication){
        this.toServiceAuthentication()
      }else {
        if (item.type) {
          if(item.type=='sellerWeb'){
            if (this.$store.state.isLogin) {
              getNewcurrent().then((data) => {
                this.identity = data.identity;
                if (this.identity === 'ENTERPRISE') {
                  findSellerSettledInfo({enterPriseId:data.enterpriseUuid}).then((items)=>{
                    if(items.data){
                        if(items.data.status=='APPROVE'){
                          this.$cookies.set("authoritiesMess", "sellerCenterService");
                          routeData = this.$url[item.type] + `#${item.link}`;
                          if (routeData != "") {
                            window.open(routeData, "_blank");
                          }
                        }else if(items.data.status=='SUBMIT'){
                          this.$message({
                            type: "warning",
                            message: "审核中，请耐心等待！",
                          });
                        }else if(items.data.status=='REJECT'){
                          this.$message({
                            type: "warning",
                            message: "服务商入驻审核拒绝，请重新入驻！",
                          });
                        }
                    }else {
                      this.$confirm('请先进行服务商入驻!', '提示', {
                        confirmButtonText: '去入驻',
                        cancelButtonText: '取消',
                        type: 'warning'
                      }).then(() => {
                        this.$router.push({
                          name: "enter",
                        });
                      });
                    }
                  })
                } else if (this.identity === 'PERSONAL' || this.identity === 'ANONYMOUS') {
                  this.$confirm('请先进行企业资质认证!', '提示', {
                    confirmButtonText: '去认证',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).then(() => {
                    window.sessionStorage.setItem("userServeId", "11");
                    let routeData = this.$router.resolve({
                      name: "userCenter",
                      params: {
                        userServeId: '11',
                      },
                    });
                    window.open(routeData.href, "_target");
                  });
                }
              })
            }else {
              /*this.$message({
                type: "error",
                message: "您需要先登录哦！",
              });*/
              /*let routeData = this.$router.resolve({
                name: "login",
              });
              // this.$router.push("/login");
              window.open(routeData, "_blank");*/
              routeData = this.$url[item.type] + `#${item.link}`;
              window.open(routeData, "_blank");
              return false;
            }
          }else {
            routeData = this.$url[item.type] + `#${item.link}`;
            if (routeData != "") {
              window.open(routeData, "_blank");
            }
          }

        } else {

          let routeData = this.$router.resolve({
            path: item.link,
          });
          window.open(routeData.href, "_blank");
        }
      }
    },
    toServiceAuthentication() {
      if (this.$store.state.isLogin) {
        getNewcurrent().then((data) => {
          console.log("--------data.identity----------",data)
          this.identity = data.identity;
          if (this.identity === 'ENTERPRISE') {
            let routeData = this.$router.resolve({
              name: "enter",
            });
            window.open(routeData.href, "_target");
          } else if (this.identity === 'PERSONAL' || this.identity === 'ANONYMOUS') {
            this.$confirm('请先进行企业资质认证!', '提示', {
              confirmButtonText: '去认证',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              window.sessionStorage.setItem("userServeId", "11");
              let routeData = this.$router.resolve({
                name: "userCenter",
                params: {
                  userServeId: '11',
                },
              });
              window.open(routeData.href, "_target");
            });
          }
        });
      } else {
        this.$message({
          type: "error",
          message: "您需要先登录哦！",
        });
        this.$router.push("/login");
        return false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-tabs--left .el-tabs__header.is-left {
  margin-right: 0;
}
/deep/.el-tabs--left.el-tabs--card .el-tabs__item.is-left {
  border-radius: 10px 0 0 10px;
  margin-bottom: 6px;
  height: 60px;
  width: 36px;
  line-height: 60px;
  text-align: center;
  border: 1px solid #e4e7ed;
  border-right: 0;
}
/deep/.el-tabs--left.el-tabs--card .el-tabs__item.is-left.is-active {
  background: #e8eef8;
}
/deep/.el-tabs__item.is-active {
  color: #000;
}
/deep/.el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
}
/deep/.el-tabs--left.el-tabs--card .el-tabs__item.is-left.is-active {
  border: none;
}
/deep/ .el-tabs--card > .el-tabs__header {
  border: none;
}
/deep/.el-tabs--left.el-tabs--card .el-tabs__item.is-left:first-child {
  border-right: none;
}
.demandServer {
  width: 1287px;
  margin: 0 auto;
  margin-top: 20px;

  .box_tabs {
    background: url("../../assets/supplyHome/demand.png") no-repeat;
    background-size: 100% 100%;
    padding: 34px 46px 17px 62px;
    box-sizing: border-box;
    color: #333333;
    width: 1200px;
    height: 452px;
    box-sizing: border-box;
    .box_tabs_title {
      font-size: 30px;
    }
    .box_tabs_mesg {
      font-size: 14px;
      font-weight: 500;
      margin: 15px 0 15px;
    }
    .demand_mesg {
      display: flex;
      .demand_mesg_box {
        width: 178px;
        height: 258px;
        background: linear-gradient(38deg, #fafbff7e, #f0f5fd81);
        border: 1px solid #ffffff;
        box-shadow: 0px 0px 18px 0px rgba(4, 0, 0, 0.06);
        border-radius: 10px;
        padding: 15px 9px 0 17px;
        box-sizing: border-box;
        margin-right: 23px;
        cursor: pointer;
        transition: all 0.5s ease 0.1s;
        &:hover {
          transform: scale(1.1);
        }
        .imgs {
          width: 82px;
          height: 90px;
        }
        .demand_mesg_nums {
          font-size: 30px;
          margin-bottom: 25px;
        }
        .demand_mesg_name {
          font-weight: bold;
          font-size: 20px;
          margin-bottom: 6px;
        }
        .demand_mesg_p {
          font-size: 14px;
          color: #333333;
          opacity: 0.5;
        }
      }
    }
    .server_mesg {
      display: flex;
      .server_box {
        display: grid;
        grid-template-columns: 178px 178px;
        grid-column-gap: 23px;
        grid-row-gap: 6px;
        flex-wrap: wrap;
        margin-right: 40px;
        .server_mesg_box {
          width: 178px;
          height: 168px;
          background: linear-gradient(38deg, #fafbff7e, #f0f5fd81);
          border: 1px solid #ffffff;
          box-shadow: 0px 0px 18px 0px rgba(4, 0, 0, 0.06);
          border-radius: 10px;
          padding: 0 9px 0 17px;
          box-sizing: border-box;
          margin-right: 23px;
          position: relative;
          cursor: pointer;
          transition: all 0.5s ease 0.1s;
          &:hover {
            transform: scale(1.1);
          }
          &:nth-last-child(1) {
            width: 378px;
            height: 98px;
            padding: 0 18px;
            .imgs {
              width: 82px;
              height: 90px;
              position: absolute;
              top: 5px;
              right: 9px;
            }
            .server_mesg_numsBox {
              display: flex;
              margin-top: 3px;
            }
            .server_mesg_nums {
              font-size: 30px;
              margin-top: 0;
              margin-right: 10px;
            }
            .server_mesg_name {
              font-weight: bold;
              font-size: 20px;
            }
            .serverP {
              margin-top: 8px;
            }
            .server_mesg_p {
              // width: 142px;
              font-size: 14px;
              color: #333333;
              opacity: 0.5;
              margin-top: 6px;
            }
          }
          .imgs {
            width: 72px;
            position: absolute;
            top: 5px;
            right: 9px;
          }
          .server_mesg_nums {
            font-size: 30px;
            margin-bottom: 9px;
            margin-top: 36px;
          }
          .server_mesg_name {
            font-weight: bold;
            font-size: 20px;
          }
          .server_mesg_p {
            font-size: 14px;
            color: #333333;
            opacity: 0.5;
            margin-top: 6px;
          }
        }
      }
      .server_mesg_img {
        width: 669px;
        height: 294px;
      }
    }
  }
  .box_tabs2 {
    background: url("../../assets/supplyHome/server.png") no-repeat !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/supplyHome/demandAndServer.vue